


export const IconColors = {
  blackFont: "#283C43",
  pinkFont: "#D08181",
  blueFont: "#3591C5",
  cyanFont: "#7FC0C5",
  blueLightFont: "#5E9BAE",
  blueDarkFont: "#52797C",
}

export const MapColors = {
  blueLine: "#355F8B",
}